var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"title":_vm.$t('My Travel'),"tabs":_vm.tabs,"containerFluid":true}})}
var staticRenderFns = []

export { render, staticRenderFns }